// snippet::snippet-systembase2[TS]

import { ComponentListenerImpl } from './ComponentListenerImpl';
import { SystemBase } from './SystemBase';
import type { Component, Entity } from '@inter-ikea-core/core';

/**
 * A type of system listening to two components
 * When implementing a system like this, do consider if you are really separating concerns properly or
 * it should really be two separate systems
 * Sometimes there is a need for a system listening to two different components though, and in that case this
 * class can be inherited to reduce a lot of the boilerplate code
 *
 * Note that in order for the system to work it must be registered with the EntityManager
 * and enabled.
 */
export abstract class SystemBase2<TComponent1 extends Component, TComponent2 extends Component> extends SystemBase<TComponent1> {
  constructor(component1Id: number, component2Id: number) {
    super(component1Id);

    this.onAddComponent2 = this.onAddComponent2.bind(this);
    this.onUpdateComponent2 = this.onUpdateComponent2.bind(this);

    this.onRemoveComponent2 = this.onRemoveComponent2.bind(this);

    this._componentListeners.push(
      new ComponentListenerImpl(this, component2Id, this.onAddComponent2, this.onUpdateComponent2, this.onRemoveComponent2)
    );
  }

  protected abstract onAddComponent2(entity: Entity, newComponent: TComponent2): void;
  protected abstract onUpdateComponent2(entity: Entity, oldComponent: TComponent2, newComponent: TComponent2): void;
  protected abstract onRemoveComponent2(entity: Entity, oldComponent: TComponent2): void;
}
// end::snippet-systembase2
